import { FC, PropsWithChildren } from 'react';
import { Layout } from 'antd';

import styles from './styles.module.scss';

export const UnauthorizedBody: FC<PropsWithChildren> = ({ children }) => {
    const { Content } = Layout;

    return <Content className={styles['body']}>{children}</Content>;
};
